import React, { FC } from 'react';

interface IPreferences {
  className: string;
}
const Preferences: FC<IPreferences> = (props) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13751_645)">
      <path
        opacity="0.4"
        d="M15.5 2H9V4H15.5C15.6326 4 15.7598 3.94732 15.8536 3.85355C15.9473 3.75979 16 3.63261 16 3.5V2.5C16 2.36739 15.9473 2.24021 15.8536 2.14645C15.7598 2.05268 15.6326 2 15.5 2ZM0.5 4H6V2H0.5C0.367392 2 0.240215 2.05268 0.146447 2.14645C0.0526784 2.24021 0 2.36739 0 2.5L0 3.5C0 3.63261 0.0526784 3.75979 0.146447 3.85355C0.240215 3.94732 0.367392 4 0.5 4ZM0.5 9H10V7H0.5C0.367392 7 0.240215 7.05268 0.146447 7.14645C0.0526784 7.24021 0 7.36739 0 7.5L0 8.5C0 8.63261 0.0526784 8.75979 0.146447 8.85355C0.240215 8.94732 0.367392 9 0.5 9ZM15.5 7H13V9H15.5C15.6326 9 15.7598 8.94732 15.8536 8.85355C15.9473 8.75979 16 8.63261 16 8.5V7.5C16 7.36739 15.9473 7.24021 15.8536 7.14645C15.7598 7.05268 15.6326 7 15.5 7ZM15.5 12H5V14H15.5C15.6326 14 15.7598 13.9473 15.8536 13.8536C15.9473 13.7598 16 13.6326 16 13.5V12.5C16 12.3674 15.9473 12.2402 15.8536 12.1464C15.7598 12.0527 15.6326 12 15.5 12ZM0 12.5V13.5C0 13.6326 0.0526784 13.7598 0.146447 13.8536C0.240215 13.9473 0.367392 14 0.5 14H2V12H0.5C0.367392 12 0.240215 12.0527 0.146447 12.1464C0.0526784 12.2402 0 12.3674 0 12.5H0Z"
        fill="#213F7D"
      />
      <path
        d="M8.5 1H7.5C7.36739 1 7.24021 1.05268 7.14645 1.14645C7.05268 1.24021 7 1.36739 7 1.5V4.5C7 4.63261 7.05268 4.75979 7.14645 4.85355C7.24021 4.94732 7.36739 5 7.5 5H8.5C8.63261 5 8.75979 4.94732 8.85355 4.85355C8.94732 4.75979 9 4.63261 9 4.5V1.5C9 1.36739 8.94732 1.24021 8.85355 1.14645C8.75979 1.05268 8.63261 1 8.5 1ZM12.5 6H11.5C11.3674 6 11.2402 6.05268 11.1464 6.14645C11.0527 6.24021 11 6.36739 11 6.5V9.5C11 9.63261 11.0527 9.75979 11.1464 9.85355C11.2402 9.94732 11.3674 10 11.5 10H12.5C12.6326 10 12.7598 9.94732 12.8536 9.85355C12.9473 9.75979 13 9.63261 13 9.5V6.5C13 6.36739 12.9473 6.24021 12.8536 6.14645C12.7598 6.05268 12.6326 6 12.5 6ZM4.5 11H3.5C3.36739 11 3.24021 11.0527 3.14645 11.1464C3.05268 11.2402 3 11.3674 3 11.5V14.5C3 14.6326 3.05268 14.7598 3.14645 14.8536C3.24021 14.9473 3.36739 15 3.5 15H4.5C4.63261 15 4.75979 14.9473 4.85355 14.8536C4.94732 14.7598 5 14.6326 5 14.5V11.5C5 11.3674 4.94732 11.2402 4.85355 11.1464C4.75979 11.0527 4.63261 11 4.5 11Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_13751_645">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Preferences;
